import { Grid, Stack, Typography, useTheme } from "@mui/material";
import { WifiOff } from "lucide-react";
import type { PropsWithChildren } from "react";
import { useOnlineStatus } from "web_myplann/Infrastructure/Hooks/useOnlineStatus";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BAR_MYPLANN_LIGHT } from "web_myplann/Utils/constants";

type Props = {
	disablePadding?: boolean;
	contentPadding?: {
		x?: number;
		y?: number;
	};
	bottomComponent?: React.ReactNode;
	disableBottomPadding?: boolean;
	bgColor?: string;
};

const PageResources = Resources;

export const HeaderBase = ({
	children,
	disablePadding,
	bottomComponent,
	disableBottomPadding,
	contentPadding,
	bgColor,
}: PropsWithChildren<Props>) => {
	const { t } = useResource();
	const isOnline = useOnlineStatus();
	const theme = useTheme();

	return (
		<Stack
			width="100%"
			bgcolor={
				bgColor ??
				((t) =>
					t.palette.mode === "dark"
						? t.palette.deprecated.grey[50]
						: BAR_MYPLANN_LIGHT)
			}
		>
			<Grid
				container
				display="flex"
				flexDirection="row"
				alignItems="center"
				sx={{
					paddingX: disablePadding ? undefined : (contentPadding?.x ?? 1.6),
					paddingY: disablePadding ? undefined : (contentPadding?.y ?? 1.6),
				}}
			>
				{children}
			</Grid>
			<Stack
				pb={bottomComponent && !disableBottomPadding ? 2 : 0}
				px={!disableBottomPadding ? 1.6 : 0}
			>
				{bottomComponent}
			</Stack>

			{!isOnline && (
				<Stack
					bgcolor={(t) => t.palette.common.white}
					border="none"
					pt={1.2}
					px={1.6}
					mb={-0.1}
				>
					<Stack
						bgcolor={(t) => t.palette.deprecated.grey[300]}
						borderRadius={0.4}
					>
						<Stack py={0.4} px={1.2} gap={1.2} direction="row">
							<WifiOff size={16} color={theme.palette.deprecated.grey[600]} />
							<Typography
								variant="deprecatedCaption"
								color={theme.palette.deprecated.grey[600]}
							>
								{t(PageResources.Auth.LoginForm.offline)}
							</Typography>
						</Stack>
					</Stack>
				</Stack>
			)}
		</Stack>
	);
};
